/** Dashboard weekly Storage / Retrieval fields on stats state. */
export type WeeklyStatsFields = {
  storageThisWeek: number | null;
  retrievalThisWeek: number | null;
};

/**
 * Build the partial stats patch for weekly metrics.
 * When there is no effective space id but the user still has spaces, return {} so React state keeps prior values
 * (avoids em dash after a successful fetch was overwritten by a transient null-id load).
 */
export function weeklyStatsPatchForDashboard(params: {
  effectiveSpaceId: string | null;
  storage: number | null;
  retrieval: number | null;
  hasAnySpace: boolean;
}): Partial<WeeklyStatsFields> {
  const { effectiveSpaceId, storage, retrieval, hasAnySpace } = params;
  if (effectiveSpaceId) {
    return {
      storageThisWeek: storage ?? 0,
      retrievalThisWeek: retrieval ?? 0,
    };
  }
  if (hasAnySpace) {
    return {};
  }
  return { storageThisWeek: null, retrievalThisWeek: null };
}
